import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as airportAction from './../../../../actions/airportAction';
import SourceFlight from './SourceFlight';

const mapStateToProps = state => {
    return {
        airlineSourceVJ: state.airportReducer.airlineSourceVJ,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
            getAirlineSourceVJ: () => dispatch(airportAction.getAirlineSourceVJ()),
            updateAirlineSource:(params)=> dispatch(airportAction.updateAirlineSource(params))
        }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SourceFlight));
